<template>
	<v-hover v-slot="{ hover }">
		<v-btn
			elevation="0"
			height="40"
			:plain="plain"
			@click="action"
			:loading="saving"
			class="wall-action-btn px-0"
			:class="{
				'accent lighten-2' : pinned,
				'grey--text text--darken-2' : pinned && !active,
				'text--darken-1' : !colorOnHover && hover,
				'success--text success lighten-3' : active && !classesOnActive,
				'grey--text' : (!active && !hover),
				'white' : !active && !pinned,
				[ colorOnHover ]: colorOnHover && hover,
				[ classesOnActive ] : active && classesOnActive,
			}">
			<v-icon v-if="icon">{{ icon }}</v-icon>
			<span v-if="text" class="d-none d-md-block ml-2">{{ text }}</span>
			<div v-if="badge" class="badge ml-1">
				{{ badge }}
			</div>
		</v-btn>
	</v-hover>
</template>

<script>
export default {
	name: "WallActionButton",
	props: {
		pinned: {
			type: Boolean,
			default: null
		},
		icon: {
			type: String,
			default: null
		},
		text: {
			type: String,
			default: null
		},
		action: {
			type: Function,
			required: true
		},
		textColor: {
			type: String,
			default: 'grey--text'
		},
		active: {
			type: Boolean,
			default: false
		},
		plain: {
			type: Boolean,
			default: false
		},
		badge: {
			type: [String, Number],
			default: null
		},
		colorOnHover: {
			type: String,
			default: null
		},
		classesOnActive: {
			type: String,
			default: null
		},
		saving: {
			type: Boolean,
			default: false
		}
	},
}
</script>

<style lang="scss">
	.badge {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		color: white;
		background: var(--v-accent-base);;
		right: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 10px;
	}
</style>
